import React from 'react';
import tpl from '../templates/swift-new';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            tooltipDisplay: false,
            tooltipElement: null
        };

        return this;
    }

    componentDidMount() {
        super.componentDidMount();
        // Ensure DOM is ready
        this.rafId = requestAnimationFrame(() => {
            this.addTooltipListeners();
        });
    }

    addTooltipListeners() {
        const tooltip = document.getElementsByClassName('tooltip')[0];
        if (tooltip && !tooltip.hasAttribute('listener')) {
            tooltip.setAttribute('listener', 'true');

            // Store references to the event handlers so we can remove them later
            this.tooltipMouseEnterHandler = e => {
                // Set tooltip immediately on mouseenter
                this.setTooltip(true, e);
            };

            this.tooltipMouseLeaveHandler = () => {
                this.setTooltip(false);
            };

            this.tooltipClickHandler = e => {
                this.setTooltip(true, e);
            };

            this.documentClickHandler = e => {
                const classList = e.target.classList;
                if (!classList.contains('tooltip') && !classList.contains('tooltip_img')) {
                    this.setTooltip(false);
                }
            };

            // Add the event listeners
            tooltip.addEventListener('mouseenter', this.tooltipMouseEnterHandler);
            tooltip.addEventListener('mouseleave', this.tooltipMouseLeaveHandler);
            tooltip.addEventListener('click', this.tooltipClickHandler);
            document.addEventListener('click', this.documentClickHandler);
        }
    }

    componentDidUpdate() {
        this.addTooltipListeners();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
        }
        this.removeTooltipListeners();
    }

    removeTooltipListeners() {
        const tooltip = document.getElementsByClassName('tooltip')[0];
        if (tooltip) {
            // Remove the event listeners using the stored references
            if (this.tooltipMouseEnterHandler) {
                tooltip.removeEventListener('mouseenter', this.tooltipMouseEnterHandler);
            }
            if (this.tooltipMouseLeaveHandler) {
                tooltip.removeEventListener('mouseleave', this.tooltipMouseLeaveHandler);
            }
            if (this.tooltipClickHandler) {
                tooltip.removeEventListener('click', this.tooltipClickHandler);
            }
            // Remove the listener attribute, so it can be reattached if component remounts
            tooltip.removeAttribute('listener');
        }

        if (this.documentClickHandler) {
            document.removeEventListener('click', this.documentClickHandler);
        }
    }

    setTooltip(display, e) {
        if (e) {
            this.setState({tooltipElement: e.currentTarget});
        }
        this.setState({tooltipDisplay: display});
    }

    static displayName = 'Transfers.Views.SWIFT';
}
